// ── 공통 유틸리티 함수 ─────────────────────────────────────────────────────────
import { toDateString } from '../../../utils/date';

/** 숫자 3자리 콤마 포맷 (예: 1234567 → "1,234,567") */
export function fmt(v) {
  const n = Number(String(v ?? '').replace(/,/g, ''));
  if (!Number.isFinite(n)) return '0';
  return n.toLocaleString('ko-KR');
}

/** YYYY-MM-DD → MM/DD 단축 표시 */
export function fmtDate(d) {
  if (!d) return '—';
  const [, m, dd] = toDateString(d).split('-');
  return `${m}/${dd}`;
}

/** 오늘 날짜 YYYY-MM-DD (KST 기준) */
export { todayKST as today } from '../../../utils/date';

/**
 * contract_items 배열 → 주계약 표시 라벨 (예: "동반할인권×500 · 여행권×100")
 * @param {Array} contractItems - [{ticketTypeName, quantity, isService}]
 */
export function contractItemsLabel(contractItems) {
  const normal = (contractItems || []).filter((i) => !i.isService);
  return normal.map((i) => `${i.ticketTypeName || '?'}×${i.quantity}`).join(' · ') || '—';
}

/**
 * contract_items 배열 → 서비스 표시 라벨 (예: "서비스권×10")
 */
export function contractServiceLabel(contractItems) {
  const svc = (contractItems || []).filter((i) => i.isService);
  return svc.map((i) => `${i.ticketTypeName || '?'}×${i.quantity}`).join(' · ');
}

/**
 * useToast()의 showToast를 { success, error } 메서드로 래핑
 * (useToast는 showToast(msg, type) 단순 함수만 반환)
 */
export function makeToast(showToast) {
  return {
    success: (msg) => showToast(msg, 'success'),
    error:   (msg) => showToast(msg, 'error'),
  };
}

/** 날짜 필드 기준 배열 오름차순 정렬 (useAdminSettlement에서 이동) */
export function sortAsc(arr, getDate) {
  return [...(arr || [])].sort((a, b) => {
    const da = String(getDate(a) || '');
    const db = String(getDate(b) || '');
    return da.localeCompare(db);
  });
}

/**
 * 좌 패널 통합 목록 생성 (clients + settlement records + others 날짜 내림차순)
 * useAdminSettlement에서 이동
 */
export function buildLeftItems(clients, records, unmatchedRevenue) {
  const arr = [];
  for (const c of (clients || []))
    arr.push({ kind: 'client', data: c, date: c.latestDate || '' });
  for (const r of (records || []))
    arr.push({ kind: 'settlement', data: r, date: toDateString(r.settlement_date || '') });
  for (const c of (unmatchedRevenue?.consultantCharges || []))
    arr.push({ kind: 'consultant_charge', data: c, date: c.settlementDate || c.settlement_date || '' });
  for (const c of (unmatchedRevenue?.consultantShareIncome || []))
    arr.push({ kind: 'consultant_share_income', data: c, date: c.date || '' });
  for (const o of (unmatchedRevenue?.others || []))
    arr.push({ kind: 'others', data: o, date: o.date || '' });
  arr.sort((a, b) => {
    if (!a.date && !b.date) return 0;
    if (!a.date) return 1;
    if (!b.date) return -1;
    return b.date.localeCompare(a.date);
  });
  return arr;
}
